<template>
    <div class="cst-survey-comments">
        <h3 v-html="$t('feedbackTitle')"></h3>
        <h2 v-html="content.title"></h2>

        <div class="cst-survey-comment cst-survey-comment-positive">
            <h3 class="feedback">{{ $t("feedbackPositiveTitle") }}</h3>
            <textarea @blur="addComments" v-model="feedbackPositive"></textarea>
        </div>

        <div class="cst-survey-comment cst-survey-comment-negative">
            <h3 class="feedback">{{ $t("feedbackNegativeTitle") }}</h3>
            <textarea @blur="addComments" v-model="feedbackNegative"></textarea>
        </div>
        <!-- <button class="feedback-btn btn-close" @click="close"><img src="../assets/cancel.svg"/></button>
        <button class="feedback-btn btn-add" @click="addComments()"><img src="../assets/ok.svg"/></button> -->
        <div class="button-bottom">
          <a class="link" @click="selectTopic">{{ $t("btnDifferentTopic" )}}</a>
          <button class="btn-ok" @click="close">{{ $t("btnOK" )}}</button>
        </div>
        <a class="btn-close" @click="close"><btn-cancel></btn-cancel></a>

    </div>    
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import CardFeedbackTopic from './CardFeedbackTopic'
    import BtnCancel from './BtnCancel'

    export default {
      props: [ 'content' ],
      data: function () {
        return {
          feedbackPositive: '',
          feedbackNegative: ''
        }
      },
      created: function () {
        var texts = this.getCurrentFeedbackTexts()
        this.feedbackPositive = texts['positive']
        this.feedbackNegative = texts['negative']
      },
      methods: {
        getCurrentFeedbackTexts: function () {
          var reviews_struct = this.$store.state.reviews
          var positiveText = ''
          var negativeText = ''
          if (reviews_struct[this.content.group_id]) {
            for (var entry_id in reviews_struct[this.content.group_id]) {
              var entry = reviews_struct[this.content.group_id][entry_id]
              if (entry['type'] === 1) {
                positiveText = entry['text']
              } else if (entry['type'] === 2) {
                negativeText = entry['text']
              }
            }
          }
          return {
            'positive': positiveText,
            'negative': negativeText
          }
        },
        addComments: function () {
          var texts = this.getCurrentFeedbackTexts()
          // dont save an empty text if there is no old text to overwrite
          if ((this.feedbackPositive !== '' || texts['positive'] !== '') || (this.feedbackNegative !== '' || texts['negative'] !== '')) {
            this.$store.dispatch('setReview', { groupId: this.content.group_id, feedbackPositive: this.feedbackPositive, feedbackNegative: this.feedbackNegative })
          }
        },
        selectTopic: function () {
          eventHub.$emit('show-modal', {type: 'card-feedback-topic', id: 9, content: { }})
        },
        close: () => {
          eventHub.$emit('close-modal')
        }
      },
      components: {
        CardFeedbackTopic, BtnCancel
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    textarea {
        .textarea;
        width: 100%;
    }
    h2 {
        text-align: center;
        color: @main-button-color;
    }
    h2 {
        font-size: 1.5em;
    }
    h3 {
        font-size: 1.2em;
        margin: 0;
    }
    .cst-survey-comment {
        margin-top: 1em;
    }
    .cst-survey-comments {
        position: relative;
        width: 100%;
        margin: auto;
        box-sizing: border-box;
        padding: 2em;
    }
    .btn-ok {
      .cst-survey-btn;
      float: right;
      margin-right: 0;
    }
    .btn-close {
      .btn-close
    } 
    h3.feedback {
      color: @text-color;
      font-size: 1.1em;
      margin-bottom: 0.5em;
    }
    .button-bottom {
      overflow: auto;
      margin-top: 0.5em;
      a {
        cursor: pointer;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/CardFeedbackComment.vue